import script from "./PigmentResult.vue?vue&type=script&setup=true&lang=js"
export * from "./PigmentResult.vue?vue&type=script&setup=true&lang=js"

import "./PigmentResult.vue?vue&type=style&index=0&id=4ee33c10&lang=less"

const __exports__ = script;

export default __exports__